<template>
  <div class="open-page-container" :class="classObject">
    <div class="fixed-header-wrapper">
      <div class="header-title">
        <logo :collapse="false" />
        <span>{{ title }}</span>
      </div>
      <QzButton
        v-if="homePage"
        type="normal"
        :height="22"
        :font-size="12"
        size="big"
        :class="{ homePage: true}"
        @click="homePageclick"
        >{{ $t('componentsOpenPageLayout.backToHomePage') }}</QzButton
      >
    </div>
    <div :class="{ main: isRight }">
      <div :class="{ left: isRight, ebk: isorderFromEbk }">
        <slot></slot>
        <el-row
          v-if="footer"
          type="flex"
          justify="end"
          align="middle"
          :class="{ 'page-bottom-wrapper': true, 'page-bottom-wrapper-ebk': isorderFromEbk }"
        >
          <slot name="footer"></slot>
          <QzButton
            v-if="showCancel"
            type="normal-reverse"
            :left="60"
            :right="20"
            :width="90"
            :font-size="18"
            size="big"
            class="cancel"
            @click="closePage"
            >{{ $t('common.cancel') }}</QzButton
          >
          <QzButton :font-size="18" size="big" @click="confirm">{{ confirmText }}</QzButton>
        </el-row>
      </div>
      <slot name="identifyMembers"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OpenPageLayout',
  components: {
    Logo: () => import('@/layout/components/Sidebar/Logo'),
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    // 是否显示返回首页
    homePage: {
      type: Boolean,
      default: false,
    },
    footer: {
      type: Boolean,
      default: true,
    },
    right: {
      type: Boolean,
      default: false,
    },
    orderFromEbk: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isorderFromEbk() {
      return this.orderFromEbk;
    },
    isRight() {
      console.log(this.right);
      return this.right;
    },
    classObject() {
      return {
        'has-footer': !!this.$slots.footer,
      };
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    closePage() {
      window.close();
    },
    homePageclick() {
      this.$router.replace({
        path: '/room-status/real-time',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-bottom-wrapper-ebk {
  width: 100% !important;
}

.ebk {
  width: 100% !important;
  flex: inherit;
}

.main {
  display: flex;
  height: 100%;

  .left {
    width: 100%;
    position: relative;
  }

  .identify-members {
    width: 280px;
  }
}

.open-page-container {
  font-weight: 500;
  min-height: 100vh;
  background-color: #f4f5f9;

  .fixed-header-wrapper {
    position: sticky;
    top: 0;
    height: 48px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    background: #2c3b4e;
    box-shadow: 0 4px 12px 0 rgba(40, 54, 65, 0.03);
    z-index: 2;

    .header-title {
      flex: 1;
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #fff;

      ::v-deep .sidebar-logo-container {
        width: auto;
        height: 48px;
        padding-top: 0;
        margin-right: 12px;
        display: flex;
        align-items: center;
        background: transparent;
      }

      ::v-deep .sidebar-logo-link {
        display: flex;
        align-items: center;
      }

      ::v-deep .sidebar-logo {
        width: 72px;
      }
    }

    .close-btn {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }

  // 底部栏
  .page-bottom-wrapper {
    position: fixed;
    width: 100%;
    height: 68px;
    bottom: 0;
    background-color: #fff;
    margin-right: 20px;
    z-index: 1;
    padding-right: 20px;
    box-shadow: 0px -4px 12px 0px rgba(177, 188, 197, 0.2);

    .handle-btn {
      width: 90px;
      height: 46px;
      background: rgba(0, 104, 182, 1);
      border-radius: 4px;
      font-size: 18px;
      margin-right: 16px;

      &.cancel {
        background-color: #fff;
        color: rgba(4, 109, 187, 1);
        border: 1px solid rgba(4, 109, 187, 1);
        margin-left: 60px;
      }
    }
  }
}

.homePage {
  background: #2c3b4e !important;
  border: 1px solid #fff !important;
  color: #fff !important;
  width: auto;
}

</style>
